// Small shared blob/data-URL helpers used by the save layer. The shape pipeline
// and several tools operate on data URLs, while Firebase Storage works in blobs,
// so we convert between them in a couple of places.

export const dataUrlToBlob = (dataUrl) => {
    const [head, body] = dataUrl.split(',');
    const mime = (head.match(/:(.*?);/) || [])[1] || 'application/octet-stream';
    const bin = atob(body);
    const len = bin.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
    return new Blob([bytes], { type: mime });
};

export const blobToDataUrl = (blob) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error || new Error('Failed to read blob'));
        reader.readAsDataURL(blob);
    });
